import { Nav } from "react-bootstrap";
//redux
import { useAppDispatch, useAppSelector } from "../../../hooks";
import { selectBoardData, setBoardData } from "../../../redux/reducer/board/boardSlice";

//-----------------------------------------------------------
export default function ClientNav() {
    //redux
    const dispatch = useAppDispatch();
    const data = useAppSelector(selectBoardData);

    //view
    return (
        <Nav.Item>
            <Nav.Link
                active={data === "client"}
                eventKey="client-link"
                onClick={() => {
                    dispatch(setBoardData("client"));
                }}
            >
                Klienci
            </Nav.Link>
        </Nav.Item>
    );
}
